/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';
import { DateComponent } from '../date/date.component';
import { IconComponent } from '../icon/icon.component';
import { MailIconComponent } from '../icons/mail-icon/mail-icon.component';

@Component({
  selector: 'ods-note',
  imports: [IconComponent, MailIconComponent, DateComponent],
  template: `@switch (type) {
      @case ('comment') {
        <ods-icon name="comment" />
      }
      @case ('wiedervorlage') {
        <ods-icon name="update" [config]="{ fill: 'error' }" />
      }
      @case ('mail') {
        <ods-mail-icon withBadge="true" />
      }
    }
    <div class="flex flex-col">
      @if (date) {
        <ods-date [date]="date" [color]="type === 'wiedervorlage' ? 'error' : 'text'" />
      }
      <span class="sr-only">{{ label }}</span>
      <ng-content />
    </div>`,
  host: { class: 'h-fit flex gap-3 p-3 border-2 border-grayborder rounded-lg bg-background-150 text-text' },
})
export class NoteComponent {
  @Input() type: 'default' | 'comment' | 'wiedervorlage' | 'mail';
  @Input() date: string | Date;
  @Input() label: string;
}
